var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShield = function SvgShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 14.2c-.4.3-.9.3-1.3 0C7 12.1 5.4 9.7 5 6.5c0-.4.3-.8.8-.9l3.9-1.1h.5l3.9 1.1c.5.1.8.6.7 1-.3 3.1-1.9 5.5-4.2 7.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.7.1h.5l8 2.2c.4.1.7.5.7 1v.1c0 4-.8 7.3-2.3 10-1.5 2.7-3.6 4.7-6.2 6.5-.3.2-.7.2-1 0-2.6-1.7-4.7-3.8-6.2-6.5-1.4-2.8-2.2-6-2.2-10v-.1c0-.4.3-.8.7-1l8-2.2zm.6 2.3h-.5L3.7 4c-.4.2-.7.6-.7 1 0 5.4 2.7 9 6.4 11.8.4.3.9.3 1.2 0C14.3 14 17 10.4 17 5c0-.4-.3-.8-.7-1l-6-1.6z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgShield;